import type { ProductMetrics } from '../../types/api'

interface GtmMethodologyPanelProps {
  metrics: ProductMetrics
}

export function GtmMethodologyPanel({ metrics }: GtmMethodologyPanelProps) {
  return (
    <details className="group">
      <summary className="cursor-pointer list-none flex items-center gap-2 text-[12px] text-muted hover:text-body">
        <span className="text-faint group-open:rotate-90 transition-transform inline-block">▶</span>
        How these numbers are calculated
      </summary>
      <div className="mt-3">
        <p className="text-[12px] text-body leading-relaxed">{metrics.methodology_disclosure}</p>
      </div>
    </details>
  )
}
